import { useMemo } from 'react'

import { observer } from 'mobx-react'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'

interface Props {
  members: string[]
  setMembers: (ids: string[]) => void
  everybody?: boolean
}

function ManualSelection({ members, setMembers, everybody = false }: Props) {
  const { canCreateEverybody, canCreateReportees } = useEngagementContext()

  const forcedFilters = useMemo(() => {
    if (everybody || canCreateEverybody) return undefined
    if (canCreateReportees) return { onlyMyReportees: true }
    return { onlyMyReportees: true, reporteesOrLed: true }
  }, [everybody, canCreateEverybody, canCreateReportees])

  return (
    <EmployeeSelectorV2
      multiple
      useAccessId
      value={members}
      onChange={(state) => {
        if (state.type === 'manual') {
          setMembers(state.ids)
        }
      }}
      forcedFilters={forcedFilters}
      options={{ disableSelectAll: true }}
    />
  )
}

export default observer(ManualSelection)
